import { createAsyncThunk } from "@reduxjs/toolkit";
import { IDeleteApiResponse } from "../utils/api.types";
import axios from "../utils/axios";

import {
    IDocSliceState,
    IDocResponse,
    IDocFormInputs,
    IUserDocAttach
} from "../utils/docAttach.types";


/**
 * Add User async Thunk.
*/
export const addDoc = createAsyncThunk(
    'user/addDoc',
    async (docReqPayload: IDocFormInputs): Promise<IDocResponse> => {
        const response = await axios.post(`/api/v1/attachments`, docReqPayload);

        return response.data;
    }
);

export const deleteDoc = createAsyncThunk(
    'user/deleteDoc',
    async (data: any): Promise<IDeleteApiResponse> => {
        const { id, collectionName, collectionRefId } = data;
        const response = await axios.delete(`/api/v1/attachments/${id}?collectionName=${collectionName}&collectionRefId=${collectionRefId}`);

        response.data['id'] = id;

        return response.data
    }
);

export const updateDocStatus = createAsyncThunk(
    'invoice/updateDocStatus',
    async ({ id, status }: any, thunkApi) => {
        try {
            let payload = {status: status};
            const response = await axios.put(`/api/v1/attachments/${id}/updateStatus`, payload);
            const { data } = response;
            if (response.status === 200) {
                return data;
            }
            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
    }
);